import { useCallback, useState } from "react";
import styled from "styled-components";
import { SP_BREAKPOINT } from "../../../constants/app";
import { SidebarMenu } from "../../../ducks/app";
import { Logo } from "../../atoms/Logo";
import { SidebarFooter } from "../../molecules/sidebar/SidebarFooter";
import { SidebarHoverMenu } from "../../molecules/sidebar/SidebarHoverMenu";
import { SidebarMenus } from "../../molecules/sidebar/SidebarMenus";

type Props = {
  clientName: string;
  username: string;
  sidebarMenusToShow: SidebarMenu[];
  selectedMenuPath: string;
  onSidebarMenuClick: (path: string) => void;
  handleLogout: () => void;
};

export const Sidebar: React.FC<Props> = ({
  clientName,
  username,
  sidebarMenusToShow,
  selectedMenuPath,
  onSidebarMenuClick,
  handleLogout,
}) => {
  const [showHoverMenu, setShowHoverMenu] = useState<boolean>(false);

  const onClickName = useCallback(() => {
    setShowHoverMenu((prev) => !prev);
    window.addEventListener("mouseup", onHideHoverMenu);
  }, []);

  const onHideHoverMenu = useCallback(() => {
    setShowHoverMenu(false);
    window.removeEventListener("mouseup", onHideHoverMenu);
  }, []);

  const onClickLogout = useCallback(() => {
    handleLogout();
    setShowHoverMenu(false);
  }, [handleLogout]);

  return (
    <StyledSideBarContainer>
      <StyledLogoContainer>
        <Logo width={135} height={28} />
      </StyledLogoContainer>

      <StyledMenusContainer>
        <SidebarMenus
          sidebarMenusToShow={sidebarMenusToShow}
          selectedMenuPath={selectedMenuPath}
          onSidebarMenuClick={onSidebarMenuClick}
        />
      </StyledMenusContainer>

      <StyledFooterContainer>
        <SidebarFooter
          clientName={clientName}
          username={username}
          handleLogout={onClickName}
        />
        <SidebarHoverMenu isShow={showHoverMenu} handleLogout={onClickLogout} />
      </StyledFooterContainer>
    </StyledSideBarContainer>
  );
};

const StyledSideBarContainer = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    display: none;
  }

  min-width: 288px;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border-right: 1px solid #cccccc;
`;

const StyledLogoContainer = styled.div`
  width: 100%;
  height: 110px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 46px 0 36px 30px;
`;

const StyledMenusContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0 20px;
  gap: 10px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const StyledFooterContainer = styled.div`
  padding: 0 20px 25px 20px;
  position: relative;
`;
